<template>
  <v-dialog
    v-model="dialog"
    hide-overlay
    fullscreen
    transition="dialog-bottom-transition"
  >
    <template #activator="{ on: dialog }">
      <v-tooltip bottom>
        <template #activator="{ on: tooltip }">
          <v-btn @click="getHistory()" icon v-on="{ ...dialog, ...tooltip }">
            <v-icon color="primary">mdi-history</v-icon>
          </v-btn>
        </template>
        <span>Your voting history</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-toolbar dense flat dark color="primary">
        <span><v-icon>mdi-history</v-icon></span>
        <v-spacer></v-spacer>
        <span>
          Voting History
        </span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-list-item two-line v-for="vote in votes" :key="vote.id">
          <v-list-item-content>
            <v-list-item-title>{{ vote.pollText }}</v-list-item-title>
            <v-list-item-subtitle>{{
              vote.voteResponse.join(", ")
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import client from "@/services/axios";
export default {
  props: ["pollId"],
  data() {
    return {
      user: {},
      dialog: false,
      votes: []
    };
  },
  methods: {
    async getHistory() {
      const result = await client.get(
        "votes/user/" + this.$store.state.user._id
      );
      this.votes = result.data;
    }
  }
};
</script>
<style scoped>
.v-dialog {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
